module.exports = __webpack_public_path__ + "static/media/logo-image.400fc494.jpg";